// Stored with the seen feature announcements, but never listed in ANNOUNCEMENTS.
export const TOUR_ID = 'sidebar-tour';

export const TOUR_LOCALE = { back: 'Back', next: 'Next', last: 'Done', skip: 'Skip tour' };

const target = (name) => `[data-tour="${name}"]`;

// Only the clickable switch, so admins who can't switch or request don't get this step.
const getEnvironmentStep = (canSwitchEnvironment) => ({
    target: `button${target('environment')}`,
    title: 'Production and Sandbox',
    content: canSwitchEnvironment
        ? 'This shows which environment you are in. Click it to switch.'
        : 'This shows which environment you are in. Click it to request a sandbox.',
    placement: 'bottom-end',
});

// Below desktop width the sidebar lives behind the menu button.
const getSmallScreenSteps = (canSwitchEnvironment) => [
    {
        target: target('menu'),
        title: 'Your new sidebar',
        content:
            'Your pages, help and account now live in this menu. You can replay this tour from Help & resources inside it.',
        placement: 'bottom-start',
    },
    getEnvironmentStep(canSwitchEnvironment),
];

// Copy follows what the admin sees: a collapsed sidebar hides group names, and admins
// without a sandbox can only request one.
const getDesktopSteps = (isCollapsed, canSwitchEnvironment) => [
    {
        target: target('nav'),
        title: 'Your new sidebar',
        content: isCollapsed
            ? 'Your pages now sit in the icon bar on the left. Hover an icon to see its name.'
            : 'Your pages now sit on the left, in groups: Medallion for identity checks, Monitoring and Configuration.',
        placement: 'right',
    },
    {
        target: target('workflows'),
        title: 'Workflows',
        content:
            'Workflows opens into a list of all your workflows, so you can jump straight to one.',
        placement: 'right',
    },
    {
        target: target('themes'),
        title: 'Themes',
        content: 'Themes work the same way, with your default theme first.',
        placement: 'right',
    },
    {
        target: target('help'),
        title: 'Help & resources',
        content:
            'Find technical docs, chat support and support tickets here. You can replay this tour from here too.',
        placement: 'right-end',
    },
    getEnvironmentStep(canSwitchEnvironment),
    {
        target: target('sidebar-toggle'),
        title: 'Need more room?',
        content: isCollapsed
            ? 'Click here to expand the sidebar and see page names again.'
            : 'Collapse the sidebar to icons. Bring it back with the button at the top left of the page.',
        placement: 'bottom',
    },
];

export const getTourSteps = ({ isSmallScreen, isCollapsed, canSwitchEnvironment }) =>
    isSmallScreen
        ? getSmallScreenSteps(canSwitchEnvironment)
        : getDesktopSteps(isCollapsed, canSwitchEnvironment);

export const JOYRIDE_STYLES = {
    options: {
        zIndex: 1500,
        arrowColor: 'var(--primary-white)',
        overlayColor: 'rgba(16, 24, 40, 0.45)',
    },
    // Nav items have a 6px radius, plus the 4px spotlight padding.
    spotlight: { borderRadius: 10 },
};
